import { useTranslation } from 'react-i18next';
import styles from './ProductivityEmptyState.module.css';

/**
 * What a card says when it has nothing to show for the selected timeframe.
 *
 * There is only one message because there is only one cause left: a site with
 * nothing measurable never renders these cards at all — the page replaces its
 * whole body with the setup checklist (see ProductivityPage). So reaching here
 * means the plan IS measurable and this particular window is simply empty.
 */
export function ProductivityEmptyState() {
  const { t } = useTranslation();

  return (
    <div className={styles.root} role="status">
      <p className={styles.message}>{t('productivity.empty.window')}</p>
      <p className={styles.hint}>{t('productivity.empty.windowHint')}</p>
    </div>
  );
}